import { Alert, Button, Grid } from "@arco-design/web-react";
import { IconPlus } from "@arco-design/web-react/icon";
import React from "react";


import MailVariantCard from "./MailVariantCard";
import CardGrid from "./CardGrid";
import { signupFlow } from "../signupFlow";

const { Row, Col } = Grid;


// A slot's own designs (role: "signup" or "followup"), as cards, and a button
// to make another. With several, each person gets one of them at random (an
// A/B test).
export default function MailVariantsEditor({campaignId, campaign, mailVariants, onChanged, role = "signup", showFlow = true}) {
    const followup = role === "followup";
    return (
        <Row>
            <Col span={24}>
                {showFlow && <Alert style={{ marginBottom: 12 }} type="info" content={signupFlow(campaign).signupEmail} />}
                <span data-fix-field={followup ? "add_followup_email" : "add_signup_email"} style={{ display: "inline-block" }}>
                    <Button type="primary" href={`/signups/` + campaignId + `/edit/mail/new` + (followup ? "?role=followup" : "")}
                        icon={<IconPlus />}>
                        {mailVariants.length ? "Add another design (A/B test)" : "Make a design"}
                    </Button>
                </span>
                {mailVariants.length > 1 && (
                    <span style={{ marginLeft: 10, fontSize: 12, color: "var(--color-text-3)" }}>
                        Each person gets one of the active designs at random; compare them by opens and signups.
                    </span>
                )}
            </Col>
            <Col span={24} style={{ marginTop: 16 }}>
                <CardGrid data-fix-field={followup ? "followup_emails" : "signup_emails"}>
                    {
                        mailVariants.map((item) => (
                            <div key={item.id} data-fix-field={`mail-variant-${item.id}`}>
                                <MailVariantCard item={item} campaignId={campaignId} onChanged={onChanged} />
                            </div>
                        ))
                    }
                </CardGrid>
            </Col>
        </Row>
    )
}
